






























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  DUBOWITZ_NEURO_ITEMS,
  DUBOWITZ_FISIK_ITEMS,
  DubowitzScores,
  dubowitzToGestationalAge,
  sumDubowitzSection,
  hasAnyDubowitzInput,
  gestationalChipColor,
  gestationalLabel,
  emptyDubowitzScores
} from "@/utils/dubowitzScore";

@Component
export default class BblDubowitzScoreCard extends Vue {
  @Prop({ default: null }) value!: DubowitzScores | null;
  @Prop({ default: false }) disabled!: boolean;

  neuroItems = DUBOWITZ_NEURO_ITEMS;
  fisikItems = DUBOWITZ_FISIK_ITEMS;
  scores: DubowitzScores = emptyDubowitzScores();
  expanded = false;

  @Watch("value", { immediate: true, deep: true })
  onValueChange(val: DubowitzScores | null) {
    const empty = emptyDubowitzScores();
    this.scores = {
      neuro: { ...empty.neuro, ...(val?.neuro || {}) },
      fisik: { ...empty.fisik, ...(val?.fisik || {}) }
    };
  }

  get neuroTotal(): number {
    return sumDubowitzSection(this.scores.neuro);
  }

  get fisikTotal(): number {
    return sumDubowitzSection(this.scores.fisik);
  }

  get totalScore(): number {
    return this.neuroTotal + this.fisikTotal;
  }

  get taksiranUmurKehamilan(): number | null {
    return hasAnyDubowitzInput(this.scores) ? dubowitzToGestationalAge(this.totalScore) : null;
  }

  get chipColor(): string {
    return gestationalChipColor(this.taksiranUmurKehamilan);
  }

  get chipLabel(): string {
    return gestationalLabel(this.taksiranUmurKehamilan);
  }

  range(min: number, max: number): number[] {
    const arr: number[] = [];
    for (let i = min; i <= max; i++) arr.push(i);
    return arr;
  }

  emitChange() {
    this.$emit("input", this.scores);
    this.$emit("change", {
      scores: this.scores,
      total: this.totalScore,
      umur_kehamilan: this.taksiranUmurKehamilan
    });
  }
}
